import $ from 'jquery';

function formTwoCol() {
	var $form 			= $('.form-two-col'),
			$formFooter = $form.find('.gform_footer'),
			$content 		= $('.prepend-right'),
			matchMedia  = window.matchMedia('(min-width: 1024px)');

	if( !matchMedia.matches ) return;

	// This is needed for AA compliance
	$formFooter.prepend('<ul class="prepend-list u-m-left--remove"></ul>');

	var $list	= $('.prepend-list');
	$list.prepend($content);
}

export { formTwoCol };